import { render } from "./WikiShoutout.vue?vue&type=template&id=8f094982"
const script = {}

import "./WikiShoutout.vue?vue&type=style&index=0&id=8f094982&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__